/** Server-enforced cap on library assets per merchant; shown as "n / 300". */
export const MEDIA_LIBRARY_QUOTA = 300;

/** Grid-friendly page size (server default 20, max 100). */
export const MEDIA_PAGE_SIZE = 24;

/** `accept` for the upload input; the server validates the real content type. */
export const MEDIA_INPUT_ACCEPT = 'image/*';
